import React from 'react';

export default function UtmKit() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H19.2C23.6804 0 25.9206 0 27.6319 0.871948C29.1372 1.63893 30.3611 2.86278 31.1281 4.36808C32 6.07937 32 8.31958 32 12.8V19.2C32 23.6804 32 25.9206 31.1281 27.6319C30.3611 29.1372 29.1372 30.3611 27.6319 31.1281C25.9206 32 23.6804 32 19.2 32H12.8C8.31958 32 6.07937 32 4.36808 31.1281C2.86278 30.3611 1.63893 29.1372 0.871948 27.6319C0 25.9206 0 23.6804 0 19.2V12.8Z'
        fill='#0F111C'
      />
      <path d='M25 12L20 7H25V12Z' fill='url(#paint0_linear_5201_5238)' />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7 7.5V15.5C7 17.433 8.567 19 10.5 19H13V22C13 23.6569 14.3431 25 16 25H22C23.6569 25 25 23.6569 25 22V13L19 7V19H13V7.5C13 7.22386 12.7761 7 12.5 7H7.5C7.22386 7 7 7.22386 7 7.5Z'
        fill='url(#paint1_linear_5201_5238)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_5201_5238'
          x1='25'
          y1='6.5'
          x2='22.5'
          y2='9.5'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#01E3FD' />
          <stop offset='1' stop-color='#0060EA' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_5201_5238'
          x1='6.86092'
          y1='3.30159'
          x2='19.9276'
          y2='22.4541'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
      </defs>
    </svg>
  );
}
